import PageTitle from "../../../Components/UI/PageTitle";
import AddOrEditLesson from "../../../Components/CoursesModuleComponents/AddOrEditLesson";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getCourseName } from "../../../apis";

const AddNewLesson = () => {
  const { courseId } = useParams();
  const [courseName, setCourseName] = useState("");
  useEffect(() => {
    getCourseName(courseId).then((response) => {
      setCourseName(response.data.name);
    });
  }, [courseId]);

  return (
    <>
      <PageTitle
        BreadcrumbItems={[
          { title: "Home", link: "/" },
          {
            title: "Courses Management",
            link: `/courses-management`,
          },
          { title: "Course Details", link: `/courses-management/${courseId}` },
          {
            title: "Lessons List",
            link: `/courses-management/${courseId}/lessons-in-course`,
          },
          { title: "Add New Lesson" },
        ]}
      />
      <h2 className="h4">
        Add Lesson To{" "}
        <span className="tw-text-primary">{courseName || ""}</span> Course
      </h2>
      <AddOrEditLesson />
    </>
  );
};

export default AddNewLesson;
